import { ReactComponent as ProfileIcon } from '../../../../assets/vectors/dashboard.svg';
import { ReactComponent as GroupIcon } from '../../../../assets/vectors/group.svg';
import { ReactComponent as HistoryIcon } from '../../../../assets/vectors/history.svg';
import { ReactComponent as UserIcon } from '../../../../assets/vectors/user.svg';
import { ReactComponent as PasswordIcon } from '../../../../assets/vectors/password.svg';
import { ReactComponent as StoreIcon } from '../../../../assets/vectors/store.svg';
import { UserRoles } from '../../../../types/models/user/user.types';
import { ProfilePages } from '../ProfileLayout.types';
import { ProfileSidebarLinksList } from './ProfileSidebar.types';

export const profileSidebarLinks: ProfileSidebarLinksList = Object.freeze({
  [UserRoles.AcheteurPublic]: [
    {
      icon: UserIcon,
      label: 'Mes informations',
      path: ProfilePages.Home,
    },
    // {
    //   icon: PasswordIcon,
    //   label: 'Mes identifiants',
    //   path: ProfilePages.Creadentials
    // },
    {
      icon: PasswordIcon,
      label: 'Mot de passe',
      path: ProfilePages.Password,
    },
    {
      icon: StoreIcon,
      label: 'Mon entité',
      path: ProfilePages.Entity,
    },
  ],
  [UserRoles.Entreprise]: [
    {
      icon: UserIcon,
      label: 'Mes informations',
      path: ProfilePages.Home,
    },
    // {
    //   icon: PasswordIcon,
    //   label: 'Mes identifiants',
    //   path: ProfilePages.Creadentials
    // },
    {
      icon: PasswordIcon,
      label: 'Mot de passe',
      path: ProfilePages.Password,
    },
    {
      icon: StoreIcon,
      label: 'Mon entreprise',
      path: ProfilePages.Company,
    },
    {
      icon: GroupIcon,
      label: 'Sous-utilisateurs',
      path: ProfilePages.SubUsers,
    },
  ],
  [UserRoles.DirecteurCommercial]: [
    {
      icon: ProfileIcon,
      label: 'Tableau de bord',
      path: ProfilePages.Home,
    },
    {
      icon: GroupIcon,
      label: 'Commerciaux',
      path: ProfilePages.Commerciaux,
    },
    {
      icon: HistoryIcon,
      label: 'Historique',
      path: ProfilePages.Historique,
    },
  ],
  [UserRoles.Commercial]: [
    {
      icon: UserIcon,
      label: 'Mes informations',
      path: ProfilePages.Home,
    },
    // {
    //   icon: PasswordIcon,
    //   label: 'Mes identifiants',
    //   path: ProfilePages.Creadentials
    // },
    {
      icon: PasswordIcon,
      label: 'Mot de passe',
      path: ProfilePages.Password,
    },
  ],
});
